import { usePatch } from "@albertine/api-client";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import type { Agent } from "../../common/types/Agent";
import { logErrorAndShowToast } from "../../utils/window.util";
import Button from "../Common/Buttons";
import Icon from "../Common/Icon";
import Label from "../Common/Label";

type Props = {
    currentAgent: Agent;
    request: string | undefined;
};

const AssignToMeButton = function AssignToMeButton(props: Props) {
    const { currentAgent, request } = props;
    const [isAssigning, setIsAssigning] = useState(false);
    const history = useHistory();
    const { mutateAsync: updateRequest } = usePatch("updateRequest", {
        onError: (error) => {
            logErrorAndShowToast(error, error.error ?? "Failed to assign request");
        },
    });

    if (!request) return null;
    return (
        <Button
            showLoadingSpinner={isAssigning}
            onClick={async (e) => {
                e.preventDefault();
                if (!request || !currentAgent) return;
                setIsAssigning(true);
                try {
                    await updateRequest({
                        param: { id: request },
                        json: { assignedTo: currentAgent.id },
                    });
                    history.push(`/request/${request}`);
                } catch {
                    // Error toast handled by mutation onError
                } finally {
                    setIsAssigning(false);
                }
            }}
            nowrap
        >
            <Icon.AssignmentAdd.Small />
            <Label.Medium.Light>Assign to me</Label.Medium.Light>
        </Button>
    );
};

export default AssignToMeButton;
